import { useVacancyPublicationUrl } from 'domain/recruiting/vacancy/publication/vacancyPublicationRoute';
import { SidebarStickyMenu, SummaryMenuItem } from 'framework/ui/menu';

const ViewVacancyPageMenu = () => {
  const { getSingleEntityUrl } = useVacancyPublicationUrl();

  return (
    <SidebarStickyMenu>
      <SummaryMenuItem linkUrl={getSingleEntityUrl()} exact />
    </SidebarStickyMenu>
  );
};

export default ViewVacancyPageMenu;
